import React, { useEffect, useState } from "react";
import { Form, Row, Col, Alert } from "react-bootstrap";
import { getUserProfile } from "../../Common/data/getUserProfile";

const PersonalDetails = () => {
    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");

    useEffect(() => {
        // Fetch user profile data when the component mounts
        const fetchUserProfile = async () => {
            try {
                const userData = await getUserProfile();
                setFullName(userData.results.fullName);
                setEmail(userData.results.email);
            } catch (error:any) {
                console.error("Error fetching user profile:", error.message);
            }
        };

        fetchUserProfile();
    }, []);

    return (
        <Row className="mb-5">
            <h3 className="mb-3">Personal Details</h3>
            <Alert variant="warning" className="mb-3">
                You cannot edit your personal details.
            </Alert>
            <Col md={6}>
                <Form.Group controlId="formBasicName">
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control 
                        type="text" 
                        placeholder="Enter your full name" 
                        value={fullName} // Set the value to the state variable
                        disabled // Make the field not editable
                    />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control 
                        type="email" 
                        placeholder="Enter your email" 
                        value={email} // Set the value to the state variable
                        disabled // Make the field not editable
                    />
                </Form.Group>
            </Col>
        </Row>
    );
};

export default PersonalDetails;
